/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserInterfaceText = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserInterfaceText model module.
   * @module model/UserInterfaceText
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserInterfaceText</code>.
   * @alias module:model/UserInterfaceText
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>UserInterfaceText</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserInterfaceText} obj Optional instance to populate.
   * @return {module:model/UserInterfaceText} The populated <code>UserInterfaceText</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('LookUpKey')) {
        obj['LookUpKey'] = ApiClient.convertToType(data['LookUpKey'], 'String');
      }
      if (data.hasOwnProperty('ContentFI')) {
        obj['ContentFI'] = ApiClient.convertToType(data['ContentFI'], 'String');
      }
      if (data.hasOwnProperty('FITranslationStatusID')) {
        obj['FITranslationStatusID'] = ApiClient.convertToType(data['FITranslationStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('FITranslationQualityStatusID')) {
        obj['FITranslationQualityStatusID'] = ApiClient.convertToType(data['FITranslationQualityStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentEN')) {
        obj['ContentEN'] = ApiClient.convertToType(data['ContentEN'], 'String');
      }
      if (data.hasOwnProperty('ENTranslationStatusID')) {
        obj['ENTranslationStatusID'] = ApiClient.convertToType(data['ENTranslationStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ENTranslationQualityStatusID')) {
        obj['ENTranslationQualityStatusID'] = ApiClient.convertToType(data['ENTranslationQualityStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentSE')) {
        obj['ContentSE'] = ApiClient.convertToType(data['ContentSE'], 'String');
      }
      if (data.hasOwnProperty('SVTranslationStatusID')) {
        obj['SVTranslationStatusID'] = ApiClient.convertToType(data['SVTranslationStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('SVTranslationQualityStatusID')) {
        obj['SVTranslationQualityStatusID'] = ApiClient.convertToType(data['SVTranslationQualityStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('HintForTranslator')) {
        obj['HintForTranslator'] = ApiClient.convertToType(data['HintForTranslator'], 'String');
      }
      if (data.hasOwnProperty('AuthorID')) {
        obj['AuthorID'] = ApiClient.convertToType(data['AuthorID'], 'Integer');
      }
      if (data.hasOwnProperty('ContextID')) {
        obj['ContextID'] = ApiClient.convertToType(data['ContextID'], 'Integer');
      }
      if (data.hasOwnProperty('LastOrderID')) {
        obj['LastOrderID'] = ApiClient.convertToType(data['LastOrderID'], 'Integer');
      }
      if (data.hasOwnProperty('TranslationVariant')) {
        obj['TranslationVariant'] = ApiClient.convertToType(data['TranslationVariant'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} LookUpKey
   * @default ''
   */
  exports.prototype['LookUpKey'] = '';
  /**
   * @member {String} ContentFI
   * @default ''
   */
  exports.prototype['ContentFI'] = '';
  /**
   * @member {Integer} FITranslationStatusID
   * @default 0
   */
  exports.prototype['FITranslationStatusID'] = 0;
  /**
   * @member {Integer} FITranslationQualityStatusID
   * @default 0
   */
  exports.prototype['FITranslationQualityStatusID'] = 0;
  /**
   * @member {String} ContentEN
   * @default ''
   */
  exports.prototype['ContentEN'] = '';
  /**
   * @member {Integer} ENTranslationStatusID
   * @default 0
   */
  exports.prototype['ENTranslationStatusID'] = 0;
  /**
   * @member {Integer} ENTranslationQualityStatusID
   * @default 0
   */
  exports.prototype['ENTranslationQualityStatusID'] = 0;
  /**
   * @member {String} ContentSE
   * @default ''
   */
  exports.prototype['ContentSE'] = '';
  /**
   * @member {Integer} SVTranslationStatusID
   * @default 0
   */
  exports.prototype['SVTranslationStatusID'] = 0;
  /**
   * @member {Integer} SVTranslationQualityStatusID
   * @default 0
   */
  exports.prototype['SVTranslationQualityStatusID'] = 0;
  /**
   * @member {String} HintForTranslator
   * @default ''
   */
  exports.prototype['HintForTranslator'] = '';
  /**
   * @member {Integer} AuthorID
   * @default 0
   */
  exports.prototype['AuthorID'] = 0;
  /**
   * @member {Integer} ContextID
   * @default 0
   */
  exports.prototype['ContextID'] = 0;
  /**
   * @member {Integer} LastOrderID
   * @default 0
   */
  exports.prototype['LastOrderID'] = 0;
  /**
   * @member {String} TranslationVariant
   * @default ''
   */
  exports.prototype['TranslationVariant'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


